import { Box, Button, Card, Flex, Grid,
    GridItem, Heading, Input, Select, Text} from '@chakra-ui/react';
   import { BsPlusLg as PlusIcon } from "react-icons/bs";
   import { IoEyeOutline as EyeIcon } from "react-icons/io5";
   import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
   import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
   import {TopLink} from '../';
   import { useState, useEffect } from 'react';
   import {openAtom,modalAtom, notificationAtom, openNAtom} from '../../../../context';
   import { useAtom } from 'jotai';
   import ViewSetting from '../Modal/ViewSetting';
   import apiCall from '../../../../utils/apiCall';
   import { useMutation, useQuery, useQueryClient } from 'react-query';
   import { Formik, Field, Form } from "formik";
   import ReactPaginate from 'react-paginate';
   import styled from '@emotion/styled';
   import { format } from 'date-fns';
   
   
   type FeeDataType ={
     Id: number;
     Name: string;
     ActionType: string;
     CreatedDate: string;
   }
   
   
   const list: FeeDataType [] = [
     {
       Id:1,
       Name:'Education Fee',
       ActionType:'3',
       CreatedDate: '11-04-23'
     },
     {
       Id:2,
       Name:'Education Fee 2',
       ActionType:'3',
       CreatedDate: '11-04-23'
     },
     {
        Id:3,
        Name:'Education Fee',
        ActionType:'3',
        CreatedDate: '11-04-23',
      },
      {
        Id:4,
        Name:'Education Fee',
        ActionType:'3',
        CreatedDate: '11-04-23',
      },
   ]
   

   const actionTypeNames: Record<number, string> = {
    1: "Application",
    2: "Membership",
    3: "Examination",
    4: "Evoting",
  };
  
   const PermissionSetUp = () => {
     const [,set_open] = useAtom(openAtom);
     const [,set_modal] = useAtom(modalAtom);
     const [,set_open_notification] = useAtom(openNAtom);
     const [,set_notification] = useAtom(notificationAtom)
     const queryClient = useQueryClient();
   
    //  const {data:feeList} = useQuery(['feeType'],{
    //    queryFn:async()=>await apiCall().get(`/MembershipSetUp/member/GetAllPermission?actionType=3`),
    //    select(data){
    //    return data.data.Data;
    //    }
    //  });
    const { data: roleList } = useQuery(['roleType'], {
      queryFn: async () =>
        await apiCall().get(`/MembershipSetUp/member/GetAllPermission`),
      select(data) {
        return data.data.Data?.filter(
          (item: any) => item.ActionType === 1 || item.ActionType === 3
        );
      },
    });
    
   
     const [filter_data,set_filter_data] = useState<any>(roleList);
     const itemsPerPage = 50;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
   
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
    useEffect(()=>{
      set_filter_data(roleList)
    },[roleList])
    
   
   
    //  const {mutate:deleteFee,isLoading:isloadingDelete} = useMutation({
    //    mutationKey:['delete-Fee-Type'],
    //    mutationFn:async(Id:number)=>{
    //      return await apiCall().get(`/exam/setup/feeType/${Id}/delete`)
    //    },
    //    onSuccess:(data:any)=>{
    //      set_notification({
    //        type:'success',
    //        message:data?.data?.Message || 'Fee deleted successfully'
    //      });
    //      set_open_notification(true);
    //      queryClient.invalidateQueries({
    //        queryKey:['feeType']
    //      })
    //    },
    //    onError(error:any){
    //      set_notification({
    //        type:'error',
    //        message:error?.data?.Message || 'Error Ocurred'
    //      });
    //      set_open_notification(true);
    //    },
    //    onSettled(){
    //      set_open(false);
    //    }
    //  })
    //  const handleDeleteFee = (Id:number) =>{
    //    set_modal({
    //      header:'Delete fee',
    //      content:<Flex  flexDir="column" gap="20px">
    //        <Text>
    //          Are you sure you want to delete this FeeSetup?
    //        </Text>
    //        <Flex p="10px 0" justify="space-between" align="center">
    //          <Button onClick={()=>set_open(false)} variant="outline" borderColor={'var(--dark-green-color'} 
    //            color="var(--dark-green-color)" >Cancel</Button>
    //          <Button onClick={()=>deleteFee(Id)} bg="var(--dark-green-color)" color="var(--white-color)">{isloadingDelete?'Loading':'Delete'}</Button>
    //        </Flex>
     
    //      </Flex>
    //    }
    //    )
    //    set_open(true);
    //  }
   
     const openAdd = (fee:FeeDataType | any) =>{
       set_modal({
         header: fee?.Id?'Update Permission':'Add Permission',
         content:<AddType {...fee} />
       })
       set_open(true);
     }
   
     const openView = (fee: FeeDataType) => {
        set_modal({
          header: 'View Permission SetUp',
          content: <ViewType fee={fee} />, // Pass the fee object
        });
        set_open(true);
      };
   
     return (
   
       <Box>
         <TopLink />
         <Flex justify="space-between" align="center" mt="20px">
           <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">Permission Setup</Heading>
           <Button bg="var(--dark-green-color)" color="var(--white-color)"onClick={()=>openAdd(null)} leftIcon={<PlusIcon />}>Add Permission</Button>
         </Flex>
         <Flex mt="25px" flexDir="column" gap="10px">
               <Heading m="0" fontSize="1rem">All Permission SetUp</Heading>
               <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
             </Flex>
         <Grid templateColumns={'repeat(1,.8fr)'} gap="20px" mt="20px">
   
          { roleList && roleList.length >0  ?roleList.map(({Id,Name,ActionType,CreatedDate}:any) => 
          <Card key={Id} as ={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row" >
               <Flex flexDir="column" gap="3px">
               <Text>
                <strong>Portal Type:</strong> {actionTypeNames[Number(ActionType)] || "Unknown"}
                </Text>
               <Text>
                  <strong>Permission Name:</strong> {Name}
                </Text>
                <Text>
           <strong>Created Date:</strong>{" "}
            {CreatedDate ? format(new Date(CreatedDate + "Z"), "dd/MM/yyyy") : "N/A"}
            </Text>


               </Flex>
               <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem">
                 <EyeIcon onClick={()=>openView({Id,Name,ActionType,CreatedDate})}  style={{cursor:'pointer'}}/>
                 <EditIcon onClick={()=>openAdd({Id,Name,ActionType,CreatedDate})} style={{cursor:'pointer'}} />
                 {/* <DeleteIcon onClick={()=>handleDeleteFee(Id)} style={{cursor:'pointer'}} /> */}
               </Flex>
           </Card>):''}
         </Grid>
         <StylePaginateBox>
           <ReactPaginate
             breakLabel="..."
             nextLabel=">"
             onPageChange={handlePageClick}
             pageRangeDisplayed={5}
             pageCount={pageCount}
             previousLabel="<"
             renderOnZeroPageCount={null}
           />
   
         </StylePaginateBox>
         
       </Box>
     
       
     )
   }
   const StylePaginateBox = styled.div`
   width:100%;
   & > ul{
     list-style-type: none;
     text-align:center;
     padding:0;
     margin:0;
     margin-top:10px;
   } 
   & > ul > li{
     display: inline;
     margin:0 5px;
     padding:2px 5px;
     border-radius: 3px;
     background-color: transparent;
     color:var(--dark-green-color);
   }
   & > ul > li.selected{
     background-color: var(--highlight-paginate-background);
     color:var(--highlight-paginate-color);
   }
   & > ul > li:first-of-type,
   & > ul > li:last-of-type{
     font-weight: bold;
   }
   `
   
   export default PermissionSetUp;
   
   const ViewType = (props:any) =>{
     const fee = props.fee;
     return (
       <ViewSetting >
        <Flex width="100%" justify="space-between" as={GridItem}>
            <span><strong>Portal Type:</strong></span> {actionTypeNames[Number(fee?.ActionType)] || "Unknown"}
            </Flex>
         <Flex width="100%" justify="space-between" as={GridItem}>
           <span><strong>Permission Name:</strong></span> {fee?.Name}</Flex>
         <Flex width="100%" justify="space-between" as={GridItem}><strong>Created Date:</strong>
         {fee?.CreatedDate ? format(new Date(fee.CreatedDate), "dd/MM/yyyy") : "N/A"}</Flex>
       </ViewSetting>
     )
   }
   
   const AddType = (props: any) => {
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_open_notification] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ['newPermission'],
      mutationFn: async (data: any) => {
        console.log("Sending data:", data); 
        return await apiCall().post(`/MembershipSetUp/member/CreateUpdatePermission`, data);
      },
      onSuccess: (data: any) => {
        set_notification({
          type: 'success',
          message: data.data.Message || 'Permission Added Successfully'
        });
        set_open_notification(true);
        queryClient.invalidateQueries(['Permission']);
      },
      onError: (error: any) => {
        set_notification({
          type: 'error',
          message: error.data.Message || 'Error Occurred'
        });
        set_open_notification(true);
      },
      onSettled: () => {
        set_open(false);
      }
    });
  
    return (
      <>
      <Formik
            initialValues={{
                Id: props.Id ?? null,  
                ActionType: props.ActionType || '',  
                Name: props.Name || '',
            }}
            enableReinitialize
            onSubmit={(values: any) => {
                const payload = {
                  ...values,
                  ActionType: Number(values.ActionType), 
                };
              
                if (!payload.Id) {
                  delete payload.Id; 
                }
              
                console.log("Final Payload:", payload); 
              
                addUpdate(payload);
              }}
              
            >


          {({ errors }) => (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">
                <Box w="100%">
                  <label>PortalType</label>
                  <Field as={Select} name="ActionType" borderColor="green" placeholder="Select Action Type">
                    <option value="1">Application</option>
                    <option value="2">Membership</option>
                    <option value="3">Examination</option>
                    <option value="4">Evoting</option>
                  </Field>
                </Box>
                  <Box w="100%">
                  <label>Permission Name</label>
                  <Field as={Input} type="text" name="Name" borderColor="green" />
                </Box>
                  <Button type="submit" color="var(--white-color)" bg="var(--dark-green-color)" disabled={isLoading}>
                  {isLoading ? "Loading" : props?.Id ? 'Update' : 'Create'}
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </>
    );
   }    